import FormattedText from '@nespresso/catalog-components-react/containers/FormattedText';
import cn from 'classnames';
import styles from './Origins.module.scss';
import useTranslations from '@/widgets/hooks/useTranslations';
import type { Product } from '@/domain/Product';

export type OriginsProps = {
  class?: string;
  product: Product;
};

export default function Origins({ class: className, product }: OriginsProps) {
  const { t } = useTranslations();

  if (!product.originDescription) {
    return null;
  }

  const originHeadingText = t('productList.quickView.origin.headingText');

  return (
    <section className={cn(styles.container, className)}>
      {originHeadingText && <h2 class={styles.heading}>{originHeadingText}</h2>}

      <FormattedText className={styles.description}>
        {product.originDescription}
      </FormattedText>
    </section>
  );
}
